const selectedAmendment = state => state.selectedAmendment

const currentResearcher = state => state.researcher

const assignedReviewers = state => state.assignedReviewers

const dates = state => state.dates

const dictums = state => state.dictums

const reviewers = state => state.reviewers

const committeeDictums = state => state.committeeDictums

const dictumTypes = state => state.dictumTypes

const readonly = state => state.readonly

const funders = state => state.funders

const financingCommitments = state => state.financingCommitments

const researchers = state => state.researchers

const externalResearchers = state => state.externalResearchers

export default {
	selectedAmendment,
	currentResearcher,
	assignedReviewers,
	dates,
	dictums,
	reviewers,
	committeeDictums,
	dictumTypes,
	readonly,
	funders,
	financingCommitments,
	researchers,
	externalResearchers,
}
